import React from 'react';
import { Navigate } from 'react-router-dom';
import { useResolvedAdminAccess } from './useResolvedAdminAccess';

interface AdminRouteGuardProps {
  children: React.ReactElement;
}

const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ children }) => {
  const isAdmin = useResolvedAdminAccess();

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRouteGuard;
